import { useEffect } from 'react';

export const usePlusPayContextInit = () => {
  useEffect(() => {
    (function (d, s, id) {
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      const js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.async = true;
      js.src = '/static/ppjscontext.js'; // 自行設定正式環境或測試環境
      fjs.parentNode.insertBefore(js, fjs);
    })(document, 'script', 'PlusePay-JSContext');

    // eslint-disable-next-line
    // @ts-ignore
    window.PlusePayJSContextAsyncInit = function () {
      console.log('PPJSContext is ready');
    };
  }, []);
};
